// NEW: UI_REVAMP
export function currencyFormat(num, decimals = 0) {
	return num.toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

// Helper to parse numbers from various formats (array, comma/dash separated strings, objects)
export const parseNumbers = (val) => {
	const rawArray = Array.isArray(val) ? val : typeof val === 'string' ? val.split(/[\s,-]+/) : [];
	return rawArray
		.map((item) => {
			const v = item && typeof item === 'object' ? (item.digit ?? item.num ?? item.value) : item;
			return parseInt(v, 10);
		})
		.filter((num) => !isNaN(num));
};
